export default "__VITE_ASSET__B2Whu9$b__"